<template>
  <Modal id="RepairLogDetail" width="60%" :open="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('repairLog.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
      <DescriptionsItem :label="$t('repairLog.field.id_rep_log')">{{data.idRepLog}}</DescriptionsItem>
      <DescriptionsItem :label="$t('repairLog.field.id_car')">{{data.carModel}}</DescriptionsItem>
      <DescriptionsItem :label="$t('repairLog.field.amount')">{{data.amount}}</DescriptionsItem>
      <DescriptionsItem :label="$t('repairLog.field.repair_date')">{{data.repairDate}}</DescriptionsItem>
      <DescriptionsItem :label="$t('repairLog.field.remark')">{{data.remark}}</DescriptionsItem>
      <!-- <DescriptionsItem :label="$t('repairLog.field.tenant_key')">{{data.tenantKey}}</DescriptionsItem> -->
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "RepairLogDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      selectList:{
      },
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>